<template>
	<AppHeader
		:logo="logo"
		:headerButton2="headerButton2"
		hideBtn1
	/>

	<div class="flex-grow-1">
		<UiElement class="d-flex flex-column h-100 pb-0" :settings="appearance.body.settings">
			<div class="d-flex flex-column align-items-center flex-grow-1">
				<UiText :settings="heading1" class="text-center" :content="translations?.allergensTitle || '{allergensTitle}'">
				</UiText>

				<div class="row w-100">
					<div v-for="(col, colIndex) in allergensList" :key="`col-${colIndex}`" class="col-6">
						<div style="margin-bottom:40px">
							<div
								v-for="(item, index) in col"
								:key="`col-item-${index}`"
								style="margin-bottom:40px"
							>
								<UiText
									:settings="text1"
									style="margin-bottom:10px;"
									:content="`${item.id} ${item.name}`"
								>
								</UiText>

								<template v-if="item.children && item.children.length > 0">
									<UiText :settings="text1">
										{{ item.children.map((item) => item.name).join(', ') }}
									</UiText>
								</template>
							</div>
						</div>
					</div>
				</div>
			</div>

			<UiElement class="position-sticky bottom-0 start-0 w-100 px-0" :settings="appearance.body.settings">
				<div class="d-flex justify-content-center">
					<UiButton
						:settings="button1"
						@touchstart="goBack"
						:content="translations?.back || '{back}'"
					/>
				</div>
			</UiElement>
		</UiElement>
	</div>
</template>

<script setup>
	import { computed } from 'vue';
	import { storeToRefs } from 'pinia';
	import { useThemeStore } from '@/stores/useThemeStore';
	import { useCatalogStore } from '@/stores/useCatalogStore';
	import { useTranslationsStore } from '@/stores/useTranslationsStore';
	import { useInheritedSettings } from '@/composables/useInheritedSettings';
	import { useRouter } from 'vue-router';
	import UiElement from '@/components/UI/UiElement.vue';
	import UiText from '@/components/UI/UiText.vue';
	import UiButton from '@/components/UI/UiButton.vue';
	import AppHeader from '@/components/AppHeader.vue';
	import { useKioskStore } from '@/stores/useKioskStore';

	const router = useRouter();

	const themeStore = useThemeStore();
	const kioskStore = useKioskStore();
	const catalogStore = useCatalogStore();
	const translationsStore = useTranslationsStore();

	const { translations } = storeToRefs(translationsStore);
	const { allergens } = storeToRefs(catalogStore);
	const { locale } = storeToRefs(kioskStore);
	const { theme } = storeToRefs(themeStore);

	const page = computed(() => theme.value.pages.allergens);
	const appearance = computed(() => page.value.appearance);
	const elements = computed(() => page.value.elements);

	const heading1 = useInheritedSettings(computed(() => elements.value?.heading1));
	const text1 = useInheritedSettings(computed(() => elements.value?.text1));
	const button1 = useInheritedSettings(computed(() => elements.value?.button1));
	const logo = useInheritedSettings(computed(() => elements.value?.logo));
	const headerButton2 = useInheritedSettings(computed(() => elements.value?.headerButton2));

	const allergensList = computed(() => {
		const map = new Map();

		console.log('Allergens: ', allergens.value);

		allergens.value.forEach(item => {
			const match = item.shortName.match(/^(\d+)([a-z]*)$/i);
			if (!match) return;

			const base = match[1]; // числовая часть, например "1"
			const suffix = match[2]; // суффикс, например "a"

			const buildName = (it) =>
				it.longName[locale.value]
				|| (locale.value === 'cs' && it.longName.cz)
				|| it.longName.en
				|| `Allergen: ${it.shortName}`;

			const entry = {
				id: item.shortName,
				name: buildName(item),
			};

			if (!suffix) {
				// Это "родительский" аллерген, например "1"
				if (!map.has(base)) {
					map.set(base, { ...entry, children: [] });
				} else {
					map.set(base, { ...entry, children: map.get(base).children });
				}
			} else {
				// Это "дочерний" аллерген, например "1a"
				if (!map.has(base)) {
					map.set(base, { id: base, name: `Allergen ${base}`, children: [entry] });
				} else {
					map.get(base).children.push(entry);
				}
			}
		});

		// Сортировка по числовой части
		const sorted = Array.from(map.entries())
			.sort((a, b) => parseInt(a[0]) - parseInt(b[0]))
			.map(([, value]) => value);

		// Разделение пополам
		const mid = Math.ceil(sorted.length / 2);
		return [sorted.slice(0, mid), sorted.slice(mid)];
	});


	function goBack() {
		router.go(-1);
	}
</script>